import { mainApi } from "services/main";
import {
  CreateScanJobRequest,
  CreateScanJobResponse,
  UpdateScanJobRequest,
  UpdateScanJobResponse,
} from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    createScanJob: builder.mutation<
      CreateScanJobResponse,
      CreateScanJobRequest
    >({
      query: (request: CreateScanJobRequest) => ({
        url: "scan-jobs/",
        method: "POST",
        body: request,
      }),
    }),
    updateScanJob: builder.mutation<
      UpdateScanJobResponse,
      UpdateScanJobRequest
    >({
      query: (request: UpdateScanJobRequest) => {
        return {
          url: `scan-jobs/${request.shortId}`,
          method: "PUT",
          body: request,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useCreateScanJobMutation, useUpdateScanJobMutation } =
  extendedApi;
